export default __webpack_public_path__ + "static/size-b2bbaac182f187413c019b243ba0e52f.png";